export class CalendarConstants {
    public static readonly CalendarHeaderDaysLabels = [
        { id: 7, labelAbbr: 'S', label: 'Sunday' },
        { id: 1, labelAbbr: 'M', label: 'Monday' },
        { id: 2, labelAbbr: 'T', label: 'Tuesday' },
        { id: 3, labelAbbr: 'W', label: 'Wednesday' },
        { id: 4, labelAbbr: 'T', label: 'Thursday' },
        { id: 5, labelAbbr: 'F', label: 'Friday' },
        { id: 6, labelAbbr: 'S', label: 'Saturday' }
    ];
}
